// shirleyImageLoader.js - פונקציות טעינת תמונות לפרויקטים של שירלי

// רשימת פרויקטים עם סיומת JPG (אותיות גדולות)
const jpgUpperProjects = [
  'הבית האקלקטי של הודיה ועוזיה',
  'הבית של הילה מראשלצ',
  'הבית של רתם ואורטל בבאר גנים',
  'הדירה בדיזינגוף - 55 מ"ר'
];

/**
 * מחזיר את הסיומת הנכונה לפרויקט
 */
const getExtension = (projectName) => {
  return jpgUpperProjects.includes(projectName) ? 'JPG' : 'jpg';
};

/**
 * טוען thumbnail לפרויקט - כמו אצל נרקיס
 */
export const loadShirleyThumbnail = async (projectName, thumbnailIndex = 1) => {
  const extension = getExtension(projectName);
  
  try {
    // Dynamic import כמו שעשינו אצל נרקיס
    const image = await import(`../images/${projectName} ${thumbnailIndex}.${extension}`);
    return image.default;
  } catch (error) {
    // נסה עם סיומות אחרות
    const extensions = ['jpg', 'JPG', 'jpeg', 'png'];
    
    for (const ext of extensions) {
      try {
        const image = await import(`../images/${projectName} ${thumbnailIndex}.${ext}`);
        return image.default;
      } catch (e) {
        continue;
      }
    }
    
    console.error(`Failed to load thumbnail for ${projectName}`);
    throw new Error(`Could not load thumbnail for ${projectName}`);
  }
};

/**
 * טוען את כל התמונות של פרויקט - כמו אצל נרקיס
 */
export const loadShirleyProjectGallery = async (projectName, imageCount) => {
  const gallery = [];
  const extension = getExtension(projectName);
  
  for (let i = 1; i <= imageCount; i++) {
    try {
      const image = await import(`../images/${projectName} ${i}.${extension}`);
      gallery.push(image.default);
    } catch (error) {
      // נסה עם סיומות אחרות
      const extensions = ['jpg', 'JPG', 'jpeg', 'png'];
      let loaded = false;
      
      for (const ext of extensions) {
        try {
          const image = await import(`../images/${projectName} ${i}.${ext}`);
          gallery.push(image.default);
          loaded = true;
          break;
        } catch (e) {
          continue;
        }
      }
      
      if (!loaded) {
        console.warn(`Could not load image ${i} for ${projectName}`);
      }
    }
  }
  
  return gallery;
};